export const FETCH_PROGRAMS_LIST_START = 'FETCH_PROGRAMS_LIST_START';
export const FETCH_PROGRAMS_LIST_ERROR = 'FETCH_PROGRAMS_LIST_ERROR';
export const RECEIVE_PROGRAMS_LIST = 'RECEIVE_PROGRAMS_LIST';
export const CLEAR_PROGRAMS_LIST_STORE = 'CLEAR_PROGRAMS_LIST_STORE';

export const FETCH_PROGRAM_DETAILS_START = 'FETCH_PROGRAM_DETAILS_START';
export const FETCH_PROGRAM_DETAILS_ERROR = 'FETCH_PROGRAM_DETAILS_ERROR';
export const FETCH_PROGRAM_DETAILS_NOT_FOUND = 'FETCH_PROGRAM_DETAILS_NOT_FOUND';
export const RECEIVE_PROGRAM_DETAILS = 'RECEIVE_PROGRAM_DETAILS';
export const CLEAR_PROGRAM_DETAILS_STORE = 'CLEAR_PROGRAM_DETAILS_STORE';

export const CREATE_PROGRAM_DETAILS_INIT = 'CREATE_PROGRAM_DETAILS_INIT';
export const CREATE_PROGRAM_DETAILS_START = 'CREATE_PROGRAM_DETAILS_START';
export const CREATE_PROGRAM_DETAILS_SUCCESSFUL = 'CREATE_PROGRAM_DETAILS_SUCCESSFUL';
export const CREATE_PROGRAM_DETAILS_ERROR = 'CREATE_PROGRAM_DETAILS_ERROR';
export const SAVE_PROGRAM_DETAILS_START = 'SAVE_PROGRAM_DETAILS_START';
export const SAVE_PROGRAM_DETAILS_SUCCESSFUL = 'SAVE_PROGRAM_DETAILS_SUCCESSFUL';
export const SAVE_PROGRAM_DETAILS_ERROR = 'SAVE_PROGRAM_DETAILS_ERROR';

export const FETCH_PROGRAM_DAY_SCHEDULES_START = 'FETCH_PROGRAM_DAY_SCHEDULES_START';
export const FETCH_PROGRAM_DAY_SCHEDULES_ERROR = 'FETCH_PROGRAM_DAY_SCHEDULES_ERROR';
export const FETCH_PROGRAM_DAY_SCHEDULES_NOT_FOUND = 'FETCH_PROGRAM_DAY_SCHEDULES_NOT_FOUND';
export const RECEIVE_PROGRAM_DAY_SCHEDULES = 'RECEIVE_PROGRAM_DAY_SCHEDULES';
export const ADD_PROGRAM_DAY_SCHEDULE_START = 'ADD_PROGRAM_DAY_SCHEDULE_START';
export const ADD_PROGRAM_DAY_SCHEDULE_SUCCESSFUL = 'ADD_PROGRAM_DAY_SCHEDULE_SUCCESSFUL';
export const ADD_PROGRAM_DAY_SCHEDULE_ERROR = 'ADD_PROGRAM_DAY_SCHEDULE_ERROR';
export const EDIT_PROGRAM_DAY_SCHEDULE_START = 'EDIT_PROGRAM_DAY_SCHEDULE_START';
export const EDIT_PROGRAM_DAY_SCHEDULE_SUCCESSFUL = 'EDIT_PROGRAM_DAY_SCHEDULE_SUCCESSFUL';
export const EDIT_PROGRAM_DAY_SCHEDULE_ERROR = 'EDIT_PROGRAM_DAY_SCHEDULE_ERROR';
export const REMOVE_PROGRAM_DAY_SCHEDULE_START = 'REMOVE_PROGRAM_DAY_SCHEDULE_START';
export const REMOVE_PROGRAM_DAY_SCHEDULE_SUCCESSFUL = 'REMOVE_PROGRAM_DAY_SCHEDULE_SUCCESSFUL';
export const REMOVE_PROGRAM_DAY_SCHEDULE_ERROR = 'REMOVE_PROGRAM_DAY_SCHEDULE_ERROR';
export const CLEAR_PROGRAM_DAY_SCHEDULES_STORE = 'CLEAR_PROGRAM_DAY_SCHEDULES_STORE';
export const UPDATE_PROGRAM_DAY_SCHEDULES_SEQUENCE_SUCCESSFUL = 'UPDATE_PROGRAM_DAY_SCHEDULES_SEQUENCE_SUCCESSFUL';
export const UPDATE_PROGRAM_DAY_SCHEDULES_SEQUENCE_ERROR = 'UPDATE_PROGRAM_DAY_SCHEDULES_SEQUENCE_ERROR';
export const UPDATE_PROGRAM_DAY_COMPLEX_SCHEDULE_SEQUENCE_SUCCESSFUL = 'UPDATE_PROGRAM_DAY_COMPLEX_SCHEDULE_SEQUENCE_SUCCESSFUL';
export const UPDATE_PROGRAM_DAY_COMPLEX_SCHEDULE_SEQUENCE_ERROR = 'UPDATE_PROGRAM_DAY_COMPLEX_SCHEDULE_SEQUENCE_ERROR';

export const FETCH_PROGRAM_TYPE_CATEGORIES_START = 'FETCH_PROGRAM_TYPE_CATEGORIES_START';
export const FETCH_PROGRAM_TYPE_CATEGORIES_ERROR = 'FETCH_PROGRAM_TYPE_CATEGORIES_ERROR';
export const RECEIVE_PROGRAM_TYPE_CATEGORIES = 'RECEIVE_PROGRAM_TYPE_CATEGORIES';
export const CLEAR_PROGRAM_TYPE_CATEGORIES_STORE = 'CLEAR_PROGRAM_TYPE_CATEGORIES_STORE';

export const FETCH_PROGRAM_DAY_SCHEDULE_START = 'FETCH_PROGRAM_DAY_SCHEDULE_START';
export const FETCH_PROGRAM_DAY_SCHEDULE_ERROR = 'FETCH_PROGRAM_DAY_SCHEDULE_ERROR';
export const FETCH_PROGRAM_DAY_SCHEDULE_NOT_FOUND = 'FETCH_PROGRAM_DAY_SCHEDULE_NOT_FOUND';
export const RECEIVE_PROGRAM_DAY_SCHEDULE = 'RECEIVE_PROGRAM_DAY_SCHEDULE';
export const CLEAR_PROGRAM_DAY_SCHEDULE_STORE = 'CLEAR_PROGRAM_DAY_SCHEDULE_STORE';

export const FETCH_PROGRAM_DAY_START = 'FETCH_PROGRAM_DAY_START';
export const FETCH_PROGRAM_DAY_ERROR = 'FETCH_PROGRAM_DAY_ERROR';
export const FETCH_PROGRAM_DAY_NOT_FOUND = 'FETCH_PROGRAM_DAY_NOT_FOUND';
export const RECEIVE_PROGRAM_DAY = 'RECEIVE_PROGRAM_DAY';
export const EDIT_PROGRAM_DAY_START = 'EDIT_PROGRAM_DAY_START';
export const EDIT_PROGRAM_DAY_SUCCESSFUL = 'EDIT_PROGRAM_DAY_SUCCESSFUL';
export const EDIT_PROGRAM_DAY_ERROR = 'EDIT_PROGRAM_DAY_ERROR';
export const CLEAR_PROGRAM_DAY_STORE = 'CLEAR_PROGRAM_DAY_STORE';

export const FETCH_PROGRAM_DAY_SCHEDULES_SUMMARY_PREDICTION_START = 'FETCH_PROGRAM_DAY_SCHEDULES_SUMMARY_PREDICTION_START';
export const FETCH_PROGRAM_DAY_SCHEDULES_SUMMARY_PREDICTION_ERROR = 'FETCH_PROGRAM_DAY_SCHEDULES_SUMMARY_PREDICTION_ERROR';
export const FETCH_PROGRAM_DAY_SCHEDULES_SUMMARY_PREDICTION_NOT_FOUND = 'FETCH_PROGRAM_DAY_SCHEDULES_SUMMARY_PREDICTION_NOT_FOUND';
export const RECEIVE_PROGRAM_DAY_SCHEDULES_SUMMARY_PREDICTION = 'RECEIVE_PROGRAM_DAY_SCHEDULES_SUMMARY_PREDICTION';
export const CLEAR_PROGRAM_DAY_SCHEDULES_SUMMARY_PREDICTION_STORE = 'CLEAR_PROGRAM_DAY_SCHEDULES_SUMMARY_PREDICTION_STORE';

export const MANAGE_PROGRAM_DAYS_START = 'MANAGE_PROGRAM_DAYS_START';
export const MANAGE_PROGRAM_DAYS_SUCCESSFUL = 'MANAGE_PROGRAM_DAYS_SUCCESSFUL';
export const MANAGE_PROGRAM_DAYS_ERROR = 'MANAGE_PROGRAM_DAYS_ERROR';

export const UPDATE_PROGRAM_DAY = 'UPDATE_PROGRAM_DAY';

export const COPY_PROGRAM_DAY_START = 'COPY_PROGRAM_DAY_SCHEDULE_START';
export const COPY_PROGRAM_DAY_SUCCESSFUL = 'COPY_PROGRAM_DAY_SCHEDULE_SUCCESSFUL';
export const COPY_PROGRAM_DAY_ERROR = 'COPY_PROGRAM_DAY_SCHEDULE_ERROR';

// program day summay
export const FETCH_PROGRAM_DAY_SUMMARY_START = 'FETCH_PROGRAM_DAY_SUMMARY_START';
export const FETCH_PROGRAM_DAY_SUMMARY_ERROR = 'FETCH_PROGRAM_DAY_SUMMARY_ERROR';
export const FETCH_PROGRAM_DAY_SUMMARY_NOT_FOUND = 'FETCH_PROGRAM_DAY_SUMMARY_NOT_FOUND';
export const RECEIVE_PROGRAM_DAY_SUMMARY = 'RECEIVE_PROGRAM_DAY_SUMMARY';
export const CLEAR_PROGRAM_DAY_SUMMARY_STORE = 'CLEAR_PROGRAM_DAY_SUMMARY_STORE';
// program day summay

// recreate program day summay
export const RECREATE_PROGRAM_DAY_SUMMARY_START = 'RECREATE_PROGRAM_DAY_SUMMARY_START';
export const RECREATE_PROGRAM_DAY_SUMMARY_ERROR = 'RECREATE_PROGRAM_DAY_SUMMARY_ERROR';
export const RECREATE_PROGRAM_DAY_SUMMARY_NOT_FOUND = 'RECREATE_PROGRAM_DAY_SUMMARY_NOT_FOUND';
export const RECREATE_PROGRAM_DAY_SUMMARY_SUCCESSFUL = 'RECREATE_PROGRAM_DAY_SUMMARY_SUCCESSFUL';
// recreate program day summay

// remove day schedules
export const REMOVE_PROGRAM_DAY_SCHEDULES_START = 'REMOVE_PROGRAM_DAY_SCHEDULES_START';
export const REMOVE_PROGRAM_DAY_SCHEDULES_SUCCESSFUL = 'REMOVE_PROGRAM_DAY_SCHEDULES_SUCCESSFUL';
export const REMOVE_PROGRAM_DAY_SCHEDULES_ERROR = 'REMOVE_PROGRAM_DAY_SCHEDULES_ERROR';
// remove day schedules

export const FETCH_PROGRAM_SCHEDULES_REPORT_START = 'FETCH_PROGRAM_SCHEDULES_REPORT_START';
export const FETCH_PROGRAM_SCHEDULES_REPORT_ERROR = 'FETCH_PROGRAM_SCHEDULES_REPORT_ERROR';
export const FETCH_PROGRAM_SCHEDULES_REPORT_NOT_FOUND = 'FETCH_PROGRAM_SCHEDULES_REPORT_NOT_FOUND';
export const RECEIVE_PROGRAM_SCHEDULES_REPORT = 'RECEIVE_PROGRAM_SCHEDULES_REPORT';
export const CLEAR_PROGRAM_SCHEDULES_REPORT_STORE = 'CLEAR_PROGRAM_SCHEDULES_REPORT_STORE';

export const SAVE_PROGRAM_COPY_START = 'SAVE_PROGRAM_COPY_START';
export const SAVE_PROGRAM_COPY_ERROR = 'SAVE_PROGRAM_COPY_ERROR';
export const SAVE_PROGRAM_COPY_SUCCESSFUL = 'SAVE_PROGRAM_COPY_SUCCESSFUL';
export const CLEAR_PROGRAM_COPY_STORE = 'CLEAR_PROGRAM_COPY_STORE';

export const SAVE_PROGRAM_COVER_IMAGE_START = 'SAVE_PROGRAM_COVER_IMAGE_START';
export const SAVE_PROGRAM_COVER_IMAGE_ERROR = 'SAVE_PROGRAM_COVER_IMAGE_ERROR';
export const SAVE_PROGRAM_COVER_IMAGE_DONE = 'SAVE_PROGRAM_COVER_IMAGE_DONE';

export const REMOVE_PROGRAM_COVER_IMAGE_START = 'REMOVE_PROGRAM_COVER_IMAGE_START';
export const REMOVE_PROGRAM_COVER_IMAGE_DONE = 'REMOVE_PROGRAM_COVER_IMAGE_DONE';
export const REMOVE_PROGRAM_COVER_IMAGE_ERROR = 'REMOVE_PROGRAM_COVER_IMAGE_ERROR';

export const DELETE_PROGRAM_START = 'DELETE_PROGRAM_START';
export const DELETE_PROGRAM_ERROR = 'DELETE_PROGRAM_ERROR';
export const DELETE_PROGRAM_DONE = 'DELETE_PROGRAM_DONE';

export const PROGRAM_STATUS_TRANSITION_START = 'PROGRAM_STATUS_TRANSITION_START';
export const PROGRAM_STATUS_TRANSITION_DONE = 'PROGRAM_STATUS_TRANSITION_DONE';
export const PROGRAM_STATUS_TRANSITION_ERROR = 'PROGRAM_STATUS_TRANSITION_ERROR';

export const PROGRAM_SEND_NOTIFICATION_START = 'PROGRAM_SEND_NOTIFICATION_START';
export const PROGRAM_SEND_NOTIFICATION_DONE = 'PROGRAM_SEND_NOTIFICATION_DONE';
export const PROGRAM_SEND_NOTIFICATION_ERROR = 'PROGRAM_SEND_NOTIFICATION_ERROR';

export const CLEAR_PROGRAM_DETAILS_SAVE_ERROR = 'CLEAR_PROGRAM_DETAILS_SAVE_ERROR';



// WEBPACK FOOTER //
// ./src/store/modules/programs/mutation-types.js